import { useEffect, useState } from 'react'

// Liest die Theme-Tokens aus :root, damit Chart.js-Farben dem Light/Dark-Theme folgen.
function readTokens() {
  const s = getComputedStyle(document.documentElement)
  const g = (v: string) => s.getPropertyValue(v).trim()
  const dark = document.documentElement.getAttribute('data-theme') === 'dark'
    || (document.documentElement.getAttribute('data-theme') !== 'light'
        && window.matchMedia('(prefers-color-scheme: dark)').matches)
  return {
    text1: g('--text-1'), text2: g('--text-2'), text3: g('--text-3'),
    surface: g('--surface'), grid: g('--chart-grid'), border: g('--border-hi'),
    pos: g('--pos'), neg: g('--neg'), warn: g('--warn'), accent: g('--accent'),
    // Kategoriale Slots (dataviz-Referenzpalette, validiert für Light/Dark)
    s1: dark ? '#3987e5' : '#2a78d6',
    s2: dark ? '#d95926' : '#eb6834',
    s3: dark ? '#199e70' : '#1baf7a',
    s4: dark ? '#c98500' : '#eda100',
    s5: dark ? '#d55181' : '#e87ba4',
    s7: dark ? '#9085e9' : '#6250d6',
    dark,
  }
}
export type ChartTokens = ReturnType<typeof readTokens>

export function useChartTokens(): ChartTokens {
  const [tokens, setTokens] = useState(readTokens)
  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)')
    const update = () => setTokens(readTokens())
    const obs = new MutationObserver(update)
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] })
    mq.addEventListener('change', update)
    return () => { obs.disconnect(); mq.removeEventListener('change', update) }
  }, [])
  return tokens
}
